import { InsuranceType, MainPath } from "Constants/constants";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.SOP_SICKNESS_LEAVE}`;
export const MAX_SUM_DAILY_PAYOUT_AMOUNT = 3300;
export const MIN_SUM_DAILY_PAYOUT_AMOUNT = 100;
export const CUSTOMER_WAITING_PERIOD_BEFORE_PAYOUT_STARTS = 16;
export const CUSTOMER_MAX_AGE = 62;
export const CUSTOMER_MIN_AGE = 20;
